import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href,
  target,
  rel
}: CTAButtonProps) {
  const baseClasses = `
    relative inline-flex items-center justify-center px-8 py-4 
    text-lg font-bold text-navy-900 bg-gold-400 
    rounded-lg overflow-hidden transition-all duration-300
    hover:bg-gold-500 hover:shadow-[0_0_20px_rgba(212,175,55,0.4)]
    focus:outline-none focus:ring-2 focus:ring-gold-400 focus:ring-offset-2 focus:ring-offset-navy-900
    ${className}
  `;
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-149">{children}</span>
      <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:animate-[shimmer_1.5s_infinite]" data-id="element-150" />
    </>;
  if (href) {
    return <motion.a href={href} className={baseClasses} target={target} rel={rel} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
      if (href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        target?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      onClick?.();
    }} data-id="element-151">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={baseClasses} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-152">
      {content}
    </motion.button>;
}